<template>
    <div id="hero" class="" :ref="stepName">
        <div class="text-box button-hero">
            <b-button class="button is-primary next-button" @click="nextStep()" style="max-width: 265px">Demandez votre pack  </b-button>
        </div>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import ScrollLink from "../../../../../../views/_commons/fr/ScrollLink";

export default {
    mixins: [mixin],
    components:{ScrollLink},
    mounted(){

    }
}
</script>

